import type { ControllerRenderProps, FieldError } from "react-hook-form";
import type { ReactNode } from "react";

export interface MapRhfFieldToAtomPropsOptions {
	id?: string;
	disabled?: boolean;
	/** Transform zod message into ReactNode (e.g. icon + text). */
	mapError?: (message: string) => ReactNode;
}

export interface RhfAtomFieldProps {
	value: unknown;
	onChange: (...event: unknown[]) => void;
	onBlur: () => void;
	name: string;
	ref: ControllerRenderProps["ref"];
	error?: ReactNode;
	disabled?: boolean;
	id?: string;
}

/**
 * Maps RHF `field` + `fieldState` onto FieldType atom controlled props.
 * `error` is the string message by default; FieldShell wraps strings in StatusCallout.
 */
export function mapRhfFieldToAtomProps(
	field: Pick<
		ControllerRenderProps,
		"value" | "onChange" | "onBlur" | "name" | "ref"
	>,
	fieldState: { error?: FieldError },
	opts?: MapRhfFieldToAtomPropsOptions,
): RhfAtomFieldProps {
	const message = fieldState.error?.message;
	const error =
		typeof message === "string" && message.length > 0
			? (opts?.mapError?.(message) ?? message)
			: undefined;

	return {
		value: field.value,
		onChange: field.onChange,
		onBlur: field.onBlur,
		name: field.name,
		ref: field.ref,
		error,
		disabled: opts?.disabled,
		id: opts?.id,
	};
}
